export const encodeParam = (param) => (param ? encodeURIComponent(param) : param);

export const formatListToQueryParams = (list) => {
	if (Array.isArray(list)) {
		return list.join(",");
	}
	return null;
};
